import React from "react";
import {
  DeploymentRequestInfomationInputDialogContent,
  DeploymentRequestInfomationInputDialogStateProvider,
} from ".";

export const DeploymentRequestInfomationInputDialog = () => {
  return (
    <DeploymentRequestInfomationInputDialogStateProvider>
      <DeploymentRequestInfomationInputDialogContent></DeploymentRequestInfomationInputDialogContent>
    </DeploymentRequestInfomationInputDialogStateProvider>
  );
};
